var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-row',[_c('v-col',[_vm._l((_setup.roles),function(role){return [_c('div',{key:role.id},[_c('span',[_vm._v(_vm._s(role.positionSummary))]),_c('span',{staticClass:"px-1"},[_vm._v("-")]),_c('span',[_vm._v(_vm._s(role.agency.agencyFull))])])]})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }